import Vue from 'vue';

Vue.filter('appointmentType', value => {
  switch (value) {
    case 'MENTAL_HEALTH':
      return 'Mental Health';
    default:
      return 'Regular';
  }
});